/** 任务脱敏历史的安全投影与实际正文 Diff；未知旧数据保持 null。 */
import { z } from 'zod';
import type { LandingAiProvider } from './landing-ai-config';

export const LandingTextChangeSchema = z.object({
  before_line: z.number().int().positive().nullable(),
  after_line: z.number().int().positive().nullable(),
  before: z.string().nullable(),
  after: z.string().nullable(),
});
export type LandingTextChange = z.infer<typeof LandingTextChangeSchema>;
export const LandingTextChangesSchema = z.array(LandingTextChangeSchema);
export type LandingDesensitizationLog = {
  processing_type: 'RULE' | 'AI';
  id: string;
  landing_page_id: string;
  actor_id: string;
  status: 'SUCCEEDED' | 'NO_CHANGE' | 'FAILED';
  provider?: LandingAiProvider | null;
  model: string | null;
  language: string | null;
  word_count: number | null;
  phrase_count: number | null;
  changed_blocks: number | null;
  is_current: boolean;
  error: string | null;
  created_at: string;
};
export type LandingDesensitizationDetail = {
  log: LandingDesensitizationLog;
  diff_available: boolean;
  changes: LandingTextChange[];
};
